import { render, staticRenderFns } from "./EditableLabeledItemList.vue?vue&type=template&id=0e67b504&scoped=true&"
import script from "./EditableLabeledItemList.vue?vue&type=script&lang=ts&"
export * from "./EditableLabeledItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e67b504",
  null
  
)

export default component.exports